export class BlockProps {
  constructor(props = {}) {
    this.display = props.display;
    this.width = props.width;
    this.widthUnit = props.widthUnit;
    this.height = props.height;
    this.heightUnit = props.heightUnit;
    this.minHeight = props.minHeight;
    this.minHeightUnit = props.minHeightUnit;
    this.justifyContent = props.justifyContent;
    this.alignContent = props.alignContent;
    this.alignItems = props.alignItems;
    this.flowDirection = props.flowDirection;
    this.wrap = props.wrap;
    this.overflowX = props.overflowX;
    this.overflowY = props.overflowY;
    this.bgColor = props.bgColor;
    this.bgImage = props.bgImage;
    this.bgSize = props.bgSize;
    this.fixedTo = props.fixedTo;
    this.paddingTop = props.paddingTop;
    this.paddingBottom = props.paddingBottom;
    this.paddingLeft = props.paddingLeft;
    this.paddingRight = props.paddingRight;
    this.marginTop = props.marginTop;
    this.marginBottom = props.marginBottom;
    this.marginLeft = props.marginLeft;
    this.marginRight = props.marginRight;
    this.borderColor = props.borderColor;
    this.borderStyle = props.borderStyle;
    this.borderWidth = props.borderWidth;
    this.borderRadius = props.borderRadius;
    this.borderTopColor = props.borderTopColor;
    this.borderTopStyle = props.borderTopStyle;
    this.borderTopWidth = props.borderTopWidth;
    this.borderTopRadius = props.borderTopRadius;
    this.borderBottomColor = props.borderBottomColor;
    this.borderBottomStyle = props.borderBottomStyle;
    this.borderBottomWidth = props.borderBottomWidth;
    this.borderBottomRadius = props.borderBottomRadius;
    this.borderRightColor = props.borderRightColor;
    this.borderRightStyle = props.borderRightStyle;
    this.borderRightWidth = props.borderRightWidth;
    this.borderRightRadius = props.borderRightRadius;
    this.borderLeftColor = props.borderLeftColor;
    this.borderLeftStyle = props.borderLeftStyle;
    this.borderLeftWidth = props.borderLeftWidth;
    this.borderLeftRadius = props.borderLeftRadius;
    this.boxShadow = props.boxShadow;
    this.top = props.top;
    this.right = props.right;
    this.bottom = props.bottom;
    this.left = props.left;
    this.flexBasis = props.flexBasis;
    this.flexBasisUnit = props.flexBasisUnit;
    this.outlineColor = props.outlineColor;
    this.outlineWidth = props.outlineWidth;
    this.outlineOffset = props.outlineOffset;
    this.outlineStyle = props.outlineStyle;
    this.gridTemplateAreas = props.gridTemplateAreas;
    this.gridArea = props.gridArea;
    this.gridTemplateColumns = props.gridTemplateColumns;
    this.gridTemplateRows = props.gridTemplateRows;
    this.aspectRatio = props.aspectRatio;
    this.textAlign = props.textAlign;
    this.whiteSpace = props.whiteSpace;
    this.wordBreak = props.wordBreak;
    this.overflowWrap = props.overflowWrap;
  }

  getStyles(visible = true) {
    const bgImage = this.bgImage ? { 'background-image': `url(${this.bgImage})` } : null;
    const width = this.widthUnit === 'auto' || !this.widthUnit ? this.widthUnit : `${this.width}${this.widthUnit}`;
    const height = this.heightUnit === 'auto' || !this.heightUnit ? this.heightUnit : `${this.height}${this.heightUnit}`;
    const minHeight = this.minHeightUnit === 'auto' || !this.minHeightUnit ? this.minHeightUnit : `${this.minHeight}${this.minHeightUnit}`;
    const flexBasis = this.flexBasisUnit === 'auto' || !this.flexBasisUnit ? this.flexBasisUnit : `${this.flexBasis}${this.flexBasisUnit}`;
    const overflowX = this.overflowX === 'none' ? {} : { 'overflow-x': this.overflowX };
    const overflowY = this.overflowY === 'none' ? {} : { 'overflow-y': this.overflowY };
    const display = visible ? this.display : 'none';
    const styles = {
      ...(display && { display }),
      width,
      height,
      minHeight,
      'justify-content': this.justifyContent,
      'align-content': this.alignContent,
      'align-items': this.alignItems,
      'flex-direction': this.flowDirection,
      'flex-wrap': this.wrap,
      'background-color': this.bgColor,
      position: this.fixedTo,
      'overflow-x': this.overflowX,
      'overflow-y': this.overflowY,
      'box-sizing': 'border-box',
      'padding-top': this.paddingTop,
      'padding-bottom': this.paddingBottom,
      'padding-left': this.paddingLeft,
      'padding-right': this.paddingRight,
      'margin-top': this.marginTop,
      'margin-bottom': this.marginBottom,
      'margin-left': this.marginLeft,
      'margin-right': this.marginRight,
      'border-color': this.borderColor,
      'border-style': this.borderStyle,
      'border-width': this.borderWidth,
      'border-radius': this.borderRadius,
      'border-top-color': this.borderTopColor,
      'border-top-style': this.borderTopStyle,
      'border-top-width': this.borderTopWidth,
      'border-top-radius': this.borderTopRadius,
      'border-bottom-color': this.borderBottomColor,
      'border-bottom-style': this.borderBottomStyle,
      'border-bottom-width': this.borderBottomWidth,
      'border-bottom-radius': this.borderBottomRadius,
      'border-right-color': this.borderRightColor,
      'border-right-style': this.borderRightStyle,
      'border-right-width': this.borderRightWidth,
      'border-right-radius': this.borderRightRadius,
      'border-left-color': this.borderLeftColor,
      'border-left-style': this.borderLeftStyle,
      'border-left-width': this.borderLeftWidth,
      'border-left-radius': this.borderLeftRadius,
      'box-shadow': this.boxShadow,
      'flex-basis': flexBasis,
      'outline-offset': this.outlineOffset,
      'outline-width': this.outlineWidth,
      'outline-style': this.outlineStyle,
      'outline-color': this.outlineColor,
      'grid-template-areas': this.gridTemplateAreas,
      'grid-area': this.gridArea,
      'grid-template-columns': this.gridTemplateColumns,
      'grid-template-rows': this.gridTemplateRows,
      'background-size': this.bgSize,
      'aspect-ratio': this.aspectRatio,
      textAlign: this.textAlign,
      'white-space': this.whiteSpace,
      'word-break': this.wordBreak,
      'overflow-wrap': this.overflowWrap,
      top: this.top,
      right: this.right,
      bottom: this.bottom,
      left: this.left,
      ...bgImage,
      ...overflowX,
      ...overflowY
    };
    for (let i = 0; i < Object.entries(styles).length; i++) {
      const [key, value] = Object.entries(styles)[i];
      if (value === null || value === undefined) {
        delete styles[key];
      }
    }
    return styles;
  }
}
